import SMSBoxContainer from "./SMSBoxContainer";

const LetterBox = () => {
  return (
    <div className="page-body">
      <SMSBoxContainer />
    </div>
  );
};

export default LetterBox;
